import * as React from "react"
import { Box } from "@mui/material"

import { ActionButton } from "@components"
import {useCustomDashboardsPrimorFlashOffersReportForm} from "../../../@hooks";

export default function CreateReportButton() {

    const { handleOpenForm } = useCustomDashboardsPrimorFlashOffersReportForm()

    return <Box componet="span" data-tour="flash-offers-create-report">
        <ActionButton
            label="Create New Report"
            icon="pen-to-square"
            onClick={handleOpenForm}
        />
    </Box>
}